export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (!errorMessage) return;
    if (errorMessage.indexOf('START_DATE_GREATER_THAN_END_DATE') === 0) {
      messages.push({
        message: 'validation.dateDebutGreaterDateFin',
      });
    }
    if (errorMessage.indexOf('INDEXATION_PERIODE_ALREADY_IN_YEAR') === 0) {
      messages.push({
        message: 'indexation.message.error.periodeAlreadyInYear',
      });
    }
    if (errorMessage.indexOf('INDEXATION_YEAR_ALREADY_EXIST_IN_SOCIETY') === 0) {
      messages.push({
        message: 'indexation.message.error.yearAlreadyExist',
      });
    }
    if (errorMessage.indexOf('INDEXATION_TIERS_FOURNISSEUR_ALREADY_IN_INDEXATION') === 0) {
      messages.push({ message: 'indexation.message.error.fournisseurAlreadyInIndexation' });
    }
    if (errorMessage.indexOf('INDEXATION_TIERS_CLIENT_ALREADY_IN_INDEXATION') === 0) {
      messages.push({ message: 'indexation.message.error.clientAlreadyInIndexation' });
    }
    if (errorMessage.indexOf('INDEXATION_TIERS_CLIENT_SPECIALISATION_ALREADY_IN_INDEXATION') === 0) {
      messages.push({ message: 'indexation.message.error.clientSpecialisationAlreadyInIndexation' });
    }
  });
}
